var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPogres6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_596)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.038 44.9913H12.2325C10.9251 44.9913 9.86133 43.9276 9.86133 42.62V7.47027C9.86133 6.1626 10.9249 5.09888 12.2325 5.09888H37.038C38.3456 5.09888 39.4092 6.16271 39.4092 7.47027V42.62C39.4092 43.9276 38.3456 44.9913 37.038 44.9913ZM12.2325 6.24111C11.5549 6.24111 11.0034 6.79254 11.0034 7.47041V42.6199C11.0034 43.2977 11.5549 43.849 12.2325 43.849H37.038C37.7157 43.849 38.2671 43.2976 38.2671 42.6199V7.47014C38.2671 6.79238 37.7157 6.24085 37.038 6.24085L12.2325 6.24111Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7619 28.859H16.5066C16.1911 28.859 15.9355 28.6033 15.9355 28.2879C15.9355 27.9725 16.1911 27.7168 16.5066 27.7168H32.7618C33.0773 27.7168 33.3329 27.9725 33.3329 28.2879C33.3329 28.6033 33.0772 28.859 32.7619 28.859Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7619 34.4414H16.5066C16.1911 34.4414 15.9355 34.1858 15.9355 33.8704C15.9355 33.555 16.1911 33.2993 16.5066 33.2993H32.7618C33.0773 33.2993 33.3329 33.555 33.3329 33.8704C33.3329 34.1858 33.0772 34.4414 32.7619 34.4414Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7619 40.0242H16.5066C16.1911 40.0242 15.9355 39.7686 15.9355 39.4531C15.9355 39.1378 16.1911 38.8821 16.5066 38.8821H32.7618C33.0773 38.8821 33.3329 39.1378 33.3329 39.4531C33.3329 39.7686 33.0772 40.0242 32.7619 40.0242Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6332 25.0005C20.5158 25.0005 17.166 21.6507 17.166 17.5332C17.166 13.4157 20.5157 10.0659 24.6332 10.0659C28.7507 10.0659 32.1006 13.4157 32.1006 17.5332C32.1005 21.6506 28.7506 25.0005 24.6332 25.0005ZM24.6332 11.208C21.1455 11.208 18.3081 14.0455 18.3081 17.5332C18.3081 21.0209 21.1456 23.8583 24.6332 23.8583C28.1209 23.8583 30.9584 21.0209 30.9584 17.5332C30.9584 14.0455 28.1209 11.208 24.6332 11.208Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.634 25.0004C23.5632 25.0004 22.595 24.1639 21.9078 22.6447C21.2858 21.2698 20.9434 19.4544 20.9434 17.5329C20.9434 15.6115 21.2857 13.7961 21.9078 12.4213C22.5951 10.9023 23.5631 10.0657 24.634 10.0657C25.7048 10.0657 26.6732 10.9022 27.3603 12.4213C27.9822 13.7961 28.3248 15.6115 28.3248 17.5329C28.3248 19.4544 27.9823 21.2697 27.3603 22.6447C26.6731 24.1639 25.7048 25.0004 24.634 25.0004ZM24.634 11.2079C23.4286 11.2079 22.0856 13.8056 22.0856 17.533C22.0856 21.2605 23.4287 23.8581 24.634 23.8581C25.8395 23.8581 27.1827 21.2606 27.1827 17.533C27.1825 13.8056 25.8395 11.2079 24.634 11.2079Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5293 18.1041H17.7371C17.4216 18.1041 17.166 17.8484 17.166 17.533C17.166 17.2176 17.4216 16.9619 17.7371 16.9619H31.5293C31.8448 16.9619 32.1004 17.2176 32.1004 17.533C32.1004 17.8484 31.8448 18.1041 31.5293 18.1041Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4321 39.9011H7.96319C6.65552 39.9011 5.5918 38.8373 5.5918 37.5296V2.38018C5.59169 1.07251 6.65552 0.00878906 7.96319 0.00878906H32.7683C34.0759 0.00878906 35.1397 1.07262 35.1397 2.38018V5.67008C35.1397 5.98545 34.8841 6.24113 34.5686 6.24113H12.2322C11.5545 6.24113 11.003 6.79256 11.003 7.47043V39.33C11.0031 39.6454 10.7474 39.9011 10.4321 39.9011ZM7.96319 1.15096C7.63671 1.15096 7.3284 1.27938 7.09535 1.51253C6.8622 1.74568 6.73379 2.05379 6.73379 2.38016V37.5299C6.73379 38.2077 7.28522 38.7592 7.96309 38.7592H9.86091V7.47042C9.86091 6.16274 10.9246 5.09902 12.2322 5.09902H33.9976V2.38018C33.9976 1.70252 33.4462 1.15099 32.7683 1.15099L7.96319 1.15096Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPogres6);
export default __webpack_public_path__ + "static/media/pogres6.9d3fcfb5fc87ed35c182a3f505122825.svg";
export { ForwardRef as ReactComponent };